import { Vue, Component, Prop, Watch, Setup } from "@wagich/vue-facing-decorator-metadata";
import { CustomFormField } from "../custom-form-field";

import { render } from "./richtext-content.html";


@Component({
	render
})
export class RichtextContent extends CustomFormField {
}
